// import Vue from 'vue'

const ORDER_RECEIVED = (state, order) => {
  state.waitingForRedirect = false
  state.order = order
}

const USER_DATA_UPDATED = (state, customer) => {
  state.customer = customer
}

const PAYMENT_SESSION_UPDATED = (state, payload) => {
  if (payload) {
    state.paymentSession = {
      session: payload.session,
      provider: payload.provider,
    }
  } else {
    state.paymentSession = null
  }
}

const ORDER_CLOSED = async (state, order) => {
  try {
    //get total of purchased cart
    const reducer = (accumulator, currentValue) =>
      accumulator + currentValue.total
    const orderTotal = order.orderItems.reduce(reducer, 0) // eslint-disable-line

    // if (Vue.prototype.$whitelabel.fbPixelEnabled) {
    //   Vue.analytics.fbq.event('Purchase', {
    //     value: orderTotal,
    //     currency: order.currency,
    //   })
    // }
  } catch {
    //todo some logging mechanism i guess
  }

  state.orderClosed = true
}

const OPTIN_UPDATED = (state, update) => {
  state.acceptedPhoneOptin = update.phone
  state.acceptedEmailOptin = update.email
  state.acceptedNewsletterOptin = update.newsletter
}

const NOTIFICATIONS_UPDATED = (state, notifications) => {
  state.notifications = notifications
}

export default {
  ORDER_RECEIVED,
  USER_DATA_UPDATED,
  ORDER_CLOSED,
  OPTIN_UPDATED,
  NOTIFICATIONS_UPDATED,
  PAYMENT_SESSION_UPDATED,
}
